import React, { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  FormControl,
  DropdownButton,
  FloatingLabel,
  Dropdown,
  Table,
  Alert
} from 'react-bootstrap'

import { useForm } from 'react-hook-form'
import { CONFIG } from '../../config/constant'
import { BASE } from '../../basedata/constants'
import DatePicker, { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'
import './visitorCreate.sass'

registerLocale('pt-br', ptBR)

import 'react-datepicker/dist/react-datepicker.css'

const maskCPF = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

// (00) 00000-0000
const maskPhone = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})(\d)/, '$1-$2')
}

// 00000-000
const maskCEP = (value: any) => {
  return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
}

// 00/00/0000
const maskDate = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

const isValidEmail = (email: any) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

export function GuestCreate() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    getValues,
    reset
  } = useForm()

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const [hasToken, setHasToken] = useState('')

  const [disableSign, setDisableSign] = useState(false)

  const [visitorError, setVisitorError] = useState(false)

  const [userList, setUserList] = useState([])

  const getApprovers = () => {
    fetch(`${BASE.api.base_url}${BASE.api.access_approver}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: CONFIG.API_KEY
      }
    })
      .then((resg) => resg.json())
      .then((response) => {
        setUserList(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const onSubmit = (data: any) => {
    const dateFormatePermanenceStart = new Date(startDate)
    const dateFormatePermanenceEnd = new Date(endDate)

    setDisableSign(true)
    fetch(`${BASE.api_user.base_url}${BASE.api_user.visitor_create}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        firstName: data.name.replace(/^\s+|\s+$/g, '').split(' ')[0],
        lastName: data.name.replace(/^\s+|\s+$/g, ''),
        externalId: data.title,
        type: 'guest',
        permanenceStart: dateFormatePermanenceStart,
        permanenceEnd: dateFormatePermanenceEnd,
        gender: '',
        document: '',
        document_type: '',
        email: 'guest@palmeiras.com.br',
        birthDate: new Date(),
        phoneNumber: '',
        accessCode: 'guest',
        originCompanyId: 'd5c19737-7e4e-4dd8-9931-d6bc3bc961d1'
      })
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.onboarding_url) {
          const currentToken =
            response.onboarding_url.split('com.br/?token=')[1]

          setHasToken(currentToken)
        }
      })
      .catch((error) => {
        setVisitorError(true)

        setTimeout(() => {
          setVisitorError(false)
        }, 4000)
        console.log(error)
      })
  }

  const resetForm = () => {
    setHasToken('')
    setDisableSign(false)
    reset()
  }

  useEffect(() => {
    getApprovers()
  }, [])

  return (
    <Card>
      {/* <Card.Header>
        <Card.Title as="h5">Cadastro de Visitante</Card.Title>
      </Card.Header> */}
      <Card.Body>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="mb-3">
                <Col>
                  <Form.Label>Matrícula do Associado</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Matrícula do Associado"
                    {...register('title')}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <Form.Label>Nome do convidado</Form.Label>
                  <Form.Control placeholder="Nome do convidado" {...register('name')} />
                </Col>
              </Row>
              <Row>
                <Col sm={12} xl={6}>
                  <Form.Group>
                    <Button
                      disabled={disableSign}
                      type="submit"
                      className="mb-0 w-100"
                      onClick={() => clearErrors()}
                    >
                      Cadastrar Convidado
                    </Button>
                  </Form.Group>
                </Col>
                <Col sm={12} xl={6}>
                  {disableSign && (
                    <Form.Group>
                      <Button
                        className="mb-0 btn-success w-100"
                        onClick={() => resetForm()}
                      >
                        Cadastrar Novo
                      </Button>
                    </Form.Group>
                  )}
                </Col>
              </Row>
              {visitorError && (
                <Alert variant="danger mt-3">
                  Não foi possível cadastrar o visitante. Por favor, tente
                  novamente em 5minutos
                </Alert>
              )}
            </Form>
          </Col>
        </Row>

        {hasToken && (
          <>
            <hr />
            <Row>
              <Col className="qr-wrapper">
                <h3 className="text-center">
                  Clique no botão abaixo para Tirar a Foto
                </h3>
                {/* <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&bgcolor=ffffff&data=https://visitante-palmeiras.bepass.com.br/?token=${hasToken}`}
                  className="qr-code"
                  alt="Palmeiras"
                /> */}

                <a
                  className="qr-link"
                  target="_blank"
                  rel="noreferrer"
                  href={`https://visitante-palmeiras.bepass.com.br/?token=${hasToken}`}
                >
                  Tirar Foto
                </a>
              </Col>
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  )
}
